import { BTN_JUMP, BTN_LEFT, BTN_RIGHT } from '../shared/constants.ts';

const KEYS: Record<string, number> = {
  ArrowLeft: BTN_LEFT,
  KeyA: BTN_LEFT,
  ArrowRight: BTN_RIGHT,
  KeyD: BTN_RIGHT,
  Space: BTN_JUMP,
  ArrowUp: BTN_JUMP,
  KeyW: BTN_JUMP,
  KeyZ: BTN_JUMP,
  KeyK: BTN_JUMP,
};

/** Keyboard + on-screen touch buttons, merged into the sim's input bitmask. */
export class Input {
  private keys = 0;
  private readonly touches = new Map<number, number>();
  enabled = false;

  constructor(buttons: NodeListOf<HTMLElement>) {
    window.addEventListener('keydown', (e) => {
      const b = KEYS[e.code];
      if (!b || isTyping()) return;
      if (this.enabled) e.preventDefault();
      this.keys |= b;
    });
    window.addEventListener('keyup', (e) => {
      const b = KEYS[e.code];
      if (b) this.keys &= ~b;
    });
    window.addEventListener('blur', () => {
      this.keys = 0;
      this.touches.clear();
    });

    for (const el of buttons) {
      const bit = Number(el.dataset.btn);
      const down = (e: PointerEvent) => {
        e.preventDefault();
        el.setPointerCapture?.(e.pointerId);
        this.touches.set(e.pointerId, bit);
        el.classList.add('down');
        navigator.vibrate?.(8);
      };
      const up = (e: PointerEvent) => {
        if (this.touches.get(e.pointerId) === bit) this.touches.delete(e.pointerId);
        el.classList.remove('down');
      };
      el.addEventListener('pointerdown', down);
      el.addEventListener('pointerup', up);
      el.addEventListener('pointercancel', up);
      el.addEventListener('lostpointercapture', up);
      el.addEventListener('contextmenu', (e) => e.preventDefault());
    }
  }

  bits(): number {
    if (!this.enabled) return 0;
    let b = this.keys;
    for (const v of this.touches.values()) b |= v;
    return b;
  }
}

function isTyping(): boolean {
  const el = document.activeElement;
  return el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement;
}
